import { z } from 'zod';
/** The four org-scoped lookup dimensions (replaces the prototype's stubbed loaders). */
export const LOOKUP_KINDS = ['contact-types', 'referral-sources', 'providers', 'programs'];
export function isLookupKind(k) {
    return LOOKUP_KINDS.includes(k);
}
export const lookupCreateSchema = z.object({
    name: z.string().min(1).max(120),
});
//# sourceMappingURL=lookups.js.map